var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileNavbar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    "data-stylerecorder": "true",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: 0,
      strokeWidth: 0,
      stroke: "transparent",
      fill: "rgb(48, 255, 209)",
      textAlign: "inherit",
      lineHeight: 20,
      letterSpacing: 0,
      fontWeight: 400,
      fontSize: 14
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 27h28v-3H4v3zm0-8h28v-3H4v3zM4 8v3h28V8H4z",
    "data-stylerecorder": "true",
    style: {
      fill: "rgb(48, 255, 209)",
      textAlign: "inherit",
      lineHeight: 20,
      letterSpacing: 0,
      fontWeight: 400,
      fontSize: 14
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNavbar);
export default __webpack_public_path__ + "static/media/mobile_navbar.0d8a6dbd4dfd5a7d81dfd0470a2e88aa.svg";
export { ForwardRef as ReactComponent };